import React from 'react';
import { Link, Outlet, useParams } from 'react-router-dom';
import Button from '../../../components/ui/Button';
export default function CampaignEmailHubLayout() {
  const { id } = useParams();
  const base = `/campaigns/${encodeURIComponent(id)}/email`;

  return (
    <>
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Templates & envois
          </p>
          <p className="mt-1 text-sm text-muted-foreground">
            Bibliothèque de modèles et envoi aux prospects tagués. HubUP et produits se configurent
            dans leurs onglets.
          </p>
        </div>
        <Link to={`${base}/send`}>
          <Button iconName="Send" iconPosition="left" size="lg">
            Envoyer un email
          </Button>
        </Link>
      </div>
      <Outlet />
    </>
  );
}
